module.exports = __webpack_public_path__ + "static/benefits1-0f7d65187fcd32e2056a353bdd52669d.png";